/**
* DevExpress Analytics (query-builder\widgets\masterdetaileditor\_keyColumnSurface.js)
* Version:  20.2.9
* Build date: Aug 16, 2021
* Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ko = require("knockout");
var localization_utils_1 = require("../../../property-grid/localization/localization_utils");
var KeyColumnSurface = (function () {
    function KeyColumnSurface(column, queryName, _isMaster) {
        if (_isMaster === void 0) { _isMaster = false; }
        var _this = this;
        this._isMaster = _isMaster;
        this.getTitle = function () { return _this._isMaster ? localization_utils_1.getLocalization('Master Query', 'AnalyticsCoreStringId.Wizard_MasterDetailRelationship_MasterQuery') : localization_utils_1.getLocalization('Detail Query', 'AnalyticsCoreStringId.Wizard_MasterDetailRelationship_DetailQuery'); };
        this.isSelected = ko.observable(false);
        this.selectColumnText = function () { return localization_utils_1.getLocalization('<Select a Column>', 'DataAccessUIStringId.JoinEditorEmptyColumnText'); };
        this.column = column;
        this.queryName = queryName;
        this.setColumn = function (resultColumn) {
            _this.column(resultColumn.name());
        };
    }
    return KeyColumnSurface;
}());
exports.KeyColumnSurface = KeyColumnSurface;
